module.exports = __webpack_public_path__ + "static/img/信息4.762249e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/信息4.png
// module id = GT5h
// module chunks = 1